import { createSelector } from 'reselect'
import getDomainPathFromSectionReduxUtil from 'modules/redux/utils/get-domain-path-from-section'
import getQuerySearchSelect from 'modules/search/selectors/get-query'
import { getObjectUtil } from 'packages/src'
import { getByQueryPathSuffixReduxUtil } from 'modules/redux/utils/getByQueryPathSuffix/index.js'
import { isAppSectionUtil } from 'modules/section/utils/isAppSection/index.js'
import { SECTION_TO_ITEMS } from 'modules/search/constants/index.js'
import { joinPathsStringUtil } from 'utils/string/index.js'

/**
 * Search items based on the given section and query (from the store).
 * @param  {string} section
 * @param  {string} query
 */
export function getSearchDomainListSectionSelector ({
  section,
  query
}) {
  return createSelector(
    state => {
      const isAppSection = isAppSectionUtil(section)
      if (isAppSection) {
        return state[section]
      }
      return state[getDomainPathFromSectionReduxUtil(section)]
    },
    getQuerySearchSelect,
    (
      domain,
      queryReduxState
    ) => {
      // Lowercase the query
      const queryString = (query || queryReduxState).toLowerCase()

      // Get the item objects
      let domainListPath
      if ([
        SECTION_TO_ITEMS.Plans,
        SECTION_TO_ITEMS.Workouts
      ].includes(section)) {
        domainListPath = queryString
          ? joinPathsStringUtil('recommended', getByQueryPathSuffixReduxUtil(queryString))
          : 'recommended.all'
      } else if (section === SECTION_TO_ITEMS.Exercises) {
        domainListPath = queryString
          ? joinPathsStringUtil(
              getByQueryPathSuffixReduxUtil(queryString),
              queryString // TODO fix in `loadExercisesAction`
            )
          : 'all'
      } else if (queryString) {
        domainListPath = getByQueryPathSuffixReduxUtil(queryString)
      } else {
        domainListPath = 'all'
      }

      const domainList = getObjectUtil(domain, domainListPath)

      return domainList
    }
  )
}
